import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByMonthByAuthorisingUserList from './components/month/KeysByMonthListByAuthorisingUserList';
import RequestsByWeekByAuthorisingUserList from './components/week/RequestsByWeekListByAuthorisingUser';

function KeysByAuthorisingUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by authorising user"
      MonthList={RequestsByMonthByAuthorisingUserList}
      WeekList={RequestsByWeekByAuthorisingUserList}
    />
  );
}

export default KeysByAuthorisingUser;
